import { create } from 'zustand';

interface NotificationStoreState {
  unreadCount: number;
  initialized: boolean;
  setUnreadCount: (count: number) => void;
  decrementUnread: (amount?: number) => void;
  reset: () => void;
  setInitialized: (value: boolean) => void;
}

export const useNotificationStore = create<NotificationStoreState>((set) => ({
  unreadCount: 0,
  initialized: false,
  setUnreadCount: (count) => set({ unreadCount: Math.max(0, count) }),
  decrementUnread: (amount = 1) => set((state) => ({
    unreadCount: Math.max(0, state.unreadCount - amount)
  })),
  reset: () => set({ unreadCount: 0, initialized: false }),
  setInitialized: (value) => set({ initialized: value })
}));
